import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment-timezone";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Pagination from "../layout/Pagination";
import DriverPricingModelForm from "./DriverPricingModelForm";
import PermissionGate from "../layout/PermissionGate";

const DriverPricingModel = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isBusy, setIsBusy] = useState(false);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [search, setSearch] = useState("");
    const [type, setType] = useState([]);
    const [model, setModel] = useState({});
    const [error, setError] = useState({});
    const [popup, setPopup] = useState("");
    const [popupMode, setPopupMode] = useState("");
    const token = localStorage.getItem("token");
    const limit = process.env.REACT_APP_PAGINATION_LIMIT;

    const fetchPricingModels = () => {
        axios
            .get(
                `${process.env.REACT_APP_API_ENDPOINT
                }driver-pricing/get?page=${page}&limit=${limit}&search=${search}&type=${type.join(
                    ",",
                )}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            .then((res) => {
                if (res.data.code === 1) {
                    if (page > 1) {
                        if (res.data.data.length === 0) {
                            setPage(page - 1);
                        } else {
                            setData(res.data.data);
                            setCount(res.data.count);
                            setIsLoading(false);
                        }
                    } else {
                        setData(res.data.data);
                        setCount(res.data.count);
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(false);
                }
            })
            .catch(console.error);
    };
    const validateModel = (action) => {
        const errors = {};
        if (
            model?.name === undefined ||
            model?.name === null ||
            model?.name === ""
        ) {
            errors["name"] = "Please enter name.";
        }
        if (
            model?.model === undefined ||
            model?.model === null ||
            model?.model === ""
        ) {
            errors["model"] = "Please select type.";
        }
        // if (model?.relativeDistance !== true && model?.relativeDistance !== false) {
        //   errors["relativeDistance"] = "Please select an option.";
        // }
        if (model?.model === "Flat Pricing" || model?.model === "Per Kilometer") {
            if (
                model?.price === undefined ||
                model?.price === null ||
                model?.price === "" ||
                model?.price === 0 ||
                model?.price <= 0 ||
                isNaN(model?.price)
            ) {
                errors["price"] = "Please enter a valid price.";
            }
        } else if (model?.model === "Distance Slab") {
            let hasAnyError = false;

            model?.price?.forEach((item, index) => {
                const price = Number(item?.price);
                const from = Number(item?.from);
                const to = Number(item?.to);

                let itemErrors = {};

                if (
                    item?.from === undefined ||
                    item?.from === null ||
                    item?.from === "" ||
                    isNaN(from) ||
                    from < 0
                ) {
                    itemErrors.from = "Invalid distance.";
                }

                if (
                    item?.to === undefined ||
                    item?.to === null ||
                    item?.to === "" ||
                    isNaN(to) ||
                    to <= from
                ) {
                    itemErrors.to = "Invalid distance.";
                }

                if (
                    item?.price === undefined ||
                    item?.price === null ||
                    item?.price === "" ||
                    isNaN(price) ||
                    price <= 0
                ) {
                    itemErrors.price = "Invalid price.";
                }

                if (Object.keys(itemErrors).length > 0) {
                    if (!errors.price) errors.price = [];
                    errors.price[index] = itemErrors;
                    hasAnyError = true;
                }
            });

            if (!hasAnyError) delete errors.price;
        }
        if (
            model?.model === "Distance Slab" &&
            validatePriceSlabs(model?.price) === false
        ) {
            errors["slab"] = "Incorrect price slabs.";
        }

        setError(errors);
        if (Object.keys(errors).length === 0) {
            const payload = {
                ...model,
                price:
                    model?.model === "Distance Slab"
                        ? (model.price || []).map((p) => ({
                            from: Number(p.from),
                            to: Number(p.to),
                            price: Number(p.price),
                        }))
                        : Number(model.price),
            };
            if (action === "add") {
                addModel(payload);
            } else if (action === "edit") {
                updateModel(payload);
            }
        }
    };
    const addModel = (payload) => {
        setIsBusy(true);
        axios
            .post(`${process.env.REACT_APP_API_ENDPOINT}driver-pricing/post`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                if (res.data.code === 1) {
                    setPopup("");
                    setModel({});
                    setError({});
                    fetchPricingModels();
                }
            })
            .catch(console.error)
            .finally(() => setIsBusy(false));
    };
    const updateModel = (payload) => {
        setIsBusy(true);
        axios
            .put(
                `${process.env.REACT_APP_API_ENDPOINT}driver-pricing/put/${payload?._id}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            .then((res) => {
                if (res.data.code === 1) {
                    setPopup("");
                    setModel({});
                    setError({});
                    fetchPricingModels();
                }
            })
            .catch(console.error)
            .finally(() => setIsBusy(false));
    };
    const processModelType = (modelType) => {
        if (type.includes(modelType)) {
            const prevType = [...type];
            const updatedType = [];
            prevType.map((item) => {
                if (item !== modelType) {
                    updatedType.push(item);
                }
            });
            setType(updatedType);
        } else {
            const prevType = [...type];
            prevType.push(modelType);
            setType(prevType);
        }
    };
    const processData = (type, event, field) => {
        if (type === "text") {
            const value = event.target.value;
            const newData = { ...model };
            newData[field] = value;
            const newError = { ...error };
            newError[field] = "";
            delete newError[field];
            setModel({ ...newData });
            setError({ ...newError });
        }
        if (type === "select") {
            const value = event?.value;
            const newData = { ...model };
            newData[field] = value;
            const newError = { ...error };
            newError[field] = "";
            delete newError[field];
            setModel({ ...newData });
            setError({ ...newError });
            setPopupMode(value);
        }
        if (type === "radio") {
            const value = event;
            const newData = { ...model };
            newData[field] = value;
            const newError = { ...error };
            newError[field] = "";
            delete newError[field];
            setModel({ ...newData });
            setError({ ...newError });
        }
    };
    const reset = () => {
        setPage(1);
        setSearch("");
        setType([]);
    };
    const openPopup = (action, data) => {
        setModel(data);
        setPopup(action);
    };
    const deleteModel = () => {
        if (model._id !== undefined) {
            axios
                .delete(
                    `${process.env.REACT_APP_API_ENDPOINT}driver-pricing/delete/${model?._id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    },
                )
                .then((res) => {
                    if (res.data.code === 1) {
                        setPopup("");
                        setModel({});
                        fetchPricingModels();
                    }
                })
                .catch(console.error);
        }
    };
    const addMoreSlab = () => {
        setModel((prev) => {
            const prevPrice = prev?.price || [];
            const lastTo =
                prevPrice.length > 0 ? (Number(prevPrice.at(-1)?.to) ?? 0) : 0;
            if (Number(lastTo) > 0) {
                const newError = { ...error };
                newError["slab"] = "";
                delete newError["slab"];
                setError({ ...newError });
                return {
                    ...prev,
                    price: [
                        ...prevPrice,
                        {
                            from: lastTo + 1,
                            to: null,
                            price: null,
                        },
                    ],
                };
            } else {
                setError({ ...error, slab: "Please fill up all field first" });
                return {
                    ...prev,
                    price: prevPrice,
                };
            }
        });
    };
    const removeSlab = (index) => {
        setModel((prev) => {
            const prevPrice = prev?.price || [];
            const updatedPrice = prevPrice?.filter((_, i) => i !== index);

            return {
                ...prev,
                price: updatedPrice,
            };
        });
    };
    const validatePriceSlabs = (slabs) => {
        if (!Array.isArray(slabs) || slabs.length === 0) return false;

        for (let i = 0; i < slabs.length; i++) {
            const from = Number(slabs[i]?.from);
            const to = Number(slabs[i]?.to);

            if (isNaN(from) || isNaN(to) || from > to) {
                return false;
            }

            if (i > 0 && from !== Number(slabs[i - 1]?.to) + 1) {
                return false;
            }
        }

        return true;
    };

    useEffect(() => {
        fetchPricingModels();
    }, [page, search, type]);
    useEffect(() => {
        setModel((prev) => {
            if (model.model === "Distance Slab") {
                return {
                    ...prev,
                    price: [{ from: 0, to: null, price: null }],
                };
            } else {
                return {
                    ...prev,
                    price: null,
                };
            }
        });
    }, [popupMode]);

    return isLoading === true ? (
        <Loader />
    ) : (
        <div className="d-flex flex-column flex-root">
            {/*begin::Page*/}
            <div className="page d-flex flex-row flex-column-fluid">
                {/*begin::Wrapper*/}
                <div
                    className="wrapper d-flex flex-column flex-row-fluid"
                    id="kt_wrapper"
                >
                    <Header />
                    <div className="app-body">
                        <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
                            {/*begin::Container*/}
                            <div
                                id="kt_toolbar_container"
                                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
                            >
                                {/*begin::Page title*/}
                                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                                    {/*begin::Title*/}
                                    <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                                        Driver Pricing Models
                                    </h1>
                                    {/*end::Title*/}
                                </div>
                                {/*end::Page title*/}
                                {/*begin::Actions*/}
                                <div className="d-flex align-items-center overflow-auto text-nowrap">
                                    <PermissionGate
                                        required={`view_driver_pricing_model_list`}
                                        fallback={<></>}
                                        show={false}
                                    >
                                        {/*begin::Button*/}
                                        <button
                                            onClick={() => {
                                                processModelType("Flat Pricing");
                                            }}
                                            className={
                                                type.includes("Flat Pricing")
                                                    ? "btn btn-color-light bg-primary me-3"
                                                    : "btn btn-color-primary bg-body me-3"
                                            }
                                        >
                                            Flat Pricing
                                        </button>
                                        <br />
                                        {/*end::Button*/}

                                        {/*begin::Button*/}
                                        <button
                                            onClick={() => {
                                                processModelType("Per Kilometer");
                                            }}
                                            className={
                                                type.includes("Per Kilometer")
                                                    ? "btn btn-color-light bg-info me-3"
                                                    : "btn btn-color-info bg-body me-3"
                                            }
                                        >
                                            Per Kilometer
                                        </button>
                                        <br />
                                        {/*end::Button*/}

                                        {/*begin::Button*/}
                                        <button
                                            onClick={() => {
                                                processModelType("Distance Slab");
                                            }}
                                            className={
                                                type.includes("Distance Slab")
                                                    ? "btn btn-color-light bg-warning me-3 text-nowrap"
                                                    : "btn btn-color-warning bg-body me-3 text-nowrap"
                                            }
                                        >
                                            Distance Slab
                                        </button>
                                        <br />
                                        {/*end::Button*/}

                                        {/*begin::Button*/}
                                        <button
                                            onClick={reset}
                                            className="btn btn-color-danger bg-body mx-3"
                                        >
                                            <i className="ki-duotone ki-filter text-danger-700 fs-1">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                            Reset
                                        </button>
                                        {/*end::Button*/}
                                    </PermissionGate>

                                    {/*begin::Button*/}
                                    <PermissionGate
                                        required={`add_new_driver_pricing_model`}
                                        fallback={<></>}
                                        show={false}
                                    >
                                        <button
                                            onClick={() => {
                                                setPopup("add");
                                                setModel({});
                                            }}
                                            className="btn btn-color-success bg-body mx-3"
                                        >
                                            <i className="ki-duotone ki-plus-circle text-success-700 fs-1">
                                                <span className="path1"></span>
                                                <span className="path2"></span>
                                            </i>
                                            Add New
                                        </button>
                                    </PermissionGate>
                                    {/*end::Button*/}
                                </div>
                                {/*end::Actions*/}
                            </div>
                            {/*end::Container*/}
                        </div>
                        {/*end::Toolbar*/}

                        {/*begin::Container*/}
                        <div
                            id="kt_content_container"
                            className="d-flex flex-column-fluid align-items-start  container-xxl "
                        >
                            {/*begin::Post*/}
                            <div className="content flex-row-fluid" id="kt_content">
                                {/*begin::Card*/}
                                <PermissionGate required={`view_driver_pricing_model_list`} show={false}>
                                    <div className="card">
                                        {/*begin::Card header*/}
                                        <div className="card-header border-0 pt-6">
                                            {/*begin::Search*/}
                                            <div className="my-1 w-100">
                                                <input
                                                    value={search}
                                                    onChange={(e) => {
                                                        setSearch(e.target.value);
                                                    }}
                                                    type="text"
                                                    data-kt-user-table-filter="search"
                                                    className="form-control w-100"
                                                    placeholder="Search Pricing Model"
                                                />
                                            </div>
                                            {/*end::Search*/}
                                        </div>
                                        {/*end::Card header*/}

                                        {/*begin::Card body*/}
                                        <div className="card-body py-4 text-center">
                                            {/*begin::Table*/}
                                            {data?.length === 0 ? (
                                                <div className="text-center w-100">
                                                    <img
                                                        className="w-25 mx-auto py-20"
                                                        src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                                                        alt="no-content"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="table-responsive">
                                                    <table
                                                        className="table align-middle table-row-dashed fs-6 gy-5"
                                                        id="kt_table_users"
                                                    >
                                                        <thead>
                                                            <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                                                                <th className="text-center min-w-100px">
                                                                    Driver Pricing Model
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Type
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Rate
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Created At
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Last Updated
                                                                </th>
                                                                <th className="text-center min-w-100px">
                                                                    Actions
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="text-gray-600 fw-semibold">
                                                            {data &&
                                                                data.map((pricing, index) => {
                                                                    return (
                                                                        <tr className="text-center" key={index}>
                                                                            <td>{pricing?.name}</td>
                                                                            <td>{pricing?.model}</td>
                                                                            <td>
                                                                                {pricing?.model === "Distance Slab"
                                                                                    ? "---"
                                                                                    : (pricing?.price ?? 0)}
                                                                            </td>
                                                                            <td>
                                                                                {moment(pricing.createdAt)
                                                                                    .tz(process.env.REACT_APP_TIMEZONE)
                                                                                    .format("Do MMM, YYYY")}
                                                                            </td>
                                                                            <td>
                                                                                {moment(pricing.updatedAt)
                                                                                    .tz(process.env.REACT_APP_TIMEZONE)
                                                                                    .format("Do MMM, YYYY")}
                                                                            </td>
                                                                            <td className="">
                                                                                <div className="btn-group">
                                                                                    {/*begin::Edit*/}
                                                                                    <PermissionGate
                                                                                        required={`edit_driver_pricing_model`}
                                                                                        fallback={<></>}
                                                                                    >
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                openPopup("edit", pricing);
                                                                                            }}
                                                                                            className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                                                                            data-bs-toggle="tooltip"
                                                                                            data-bs-placement="top"
                                                                                            title="Edit"
                                                                                        >
                                                                                            <i className="bi-duotone bi-pen fs-5"></i>
                                                                                        </button>
                                                                                    </PermissionGate>
                                                                                    {/*end::Edit*/}
                                                                                    {/*begin::Delete*/}
                                                                                    <PermissionGate
                                                                                        required={`delete_driver_pricing_model`}
                                                                                        fallback={<></>}
                                                                                    >
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                openPopup("delete", pricing);
                                                                                            }}
                                                                                            className="btn px-3 btn-outline btn-danger btn-color-white btn-sm"
                                                                                            data-bs-toggle="tooltip"
                                                                                            data-bs-placement="top"
                                                                                            title="Delete"
                                                                                        >
                                                                                            <i className="bi-duotone bi-trash fs-5"></i>
                                                                                        </button>
                                                                                    </PermissionGate>
                                                                                    {/*end::Delete*/}
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}
                                            {/*end::Table*/}
                                            {/*begin::Paginate*/}
                                            {count && Math.ceil(count / limit) > 1 ? (
                                                <Pagination
                                                    page={page}
                                                    setPage={setPage}
                                                    count={count}
                                                    limit={limit}
                                                />
                                            ) : (
                                                ""
                                            )}
                                            {/*end::Paginate*/}
                                        </div>
                                        {/*end::Card body*/}
                                    </div>
                                </PermissionGate>
                                {/*end::Card*/}
                            </div>
                            {/*end::Post*/}
                        </div>
                    </div>
                    {/* start :: add */}
                    <DriverPricingModelForm
                        popup={popup}
                        setPopup={setPopup}
                        model={model}
                        setModel={setModel}
                        processData={processData}
                        error={error}
                        setError={setError}
                        addMoreSlab={addMoreSlab}
                        removeSlab={removeSlab}
                        action={validateModel}
                        isBusy={isBusy}
                    />
                    {/* end :: add */}
                    {/* start :: edit */}
                    <DriverPricingModelForm
                        popup={popup}
                        setPopup={setPopup}
                        model={model}
                        setModel={setModel}
                        processData={processData}
                        error={error}
                        setError={setError}
                        addMoreSlab={addMoreSlab}
                        removeSlab={removeSlab}
                        action={validateModel}
                        isBusy={isBusy}
                    />
                    {/* end :: edit */}
                    {/* start :: delete */}
                    <div
                        className={
                            popup === "delete" ? "modal fade show d-block" : "modal fade"
                        }
                        tabIndex={-1}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content text-center bg-danger text-light">
                                <div className="modal-header">
                                    <h5 className="modal-title mx-auto text-light">DELETE</h5>
                                </div>
                                <div className="modal-body">
                                    <p className="h4 text-light">Are You Sure ?</p>
                                </div>
                                <div className="modal-footer justify-content-center">
                                    <button
                                        onClick={() => {
                                            setModel({});
                                            setPopup("");
                                        }}
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        data-bs-dismiss="modal"
                                    >
                                        No
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-light btn-sm"
                                        onClick={deleteModel}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end :: delete */}
                    <Footer />
                </div>
                {/*end::Wrapper*/}
            </div>
            {/*end::Page*/}
        </div>
    );
};

export default DriverPricingModel;